import { SCIDShopItemTier, ShortGameId } from '@common'

const translationTierSuffix = <T extends SCIDShopItemTier>(tier: T) => {
  return `_${tier.toLowerCase() as Lowercase<T>}` as const
}

export const getPassProductCopyKey = (tier: 'PREMIUM' | 'BASIC' | 'DEFAULT' | 'EVENT', shortSlug: ShortGameId) => {
  switch (shortSlug) {
    case 'coc':
      if (tier === 'EVENT') {
        return `coc_pass_product_name_event` as const
      }

      return `coc_pass_product_name_default` as const
    case 'bs':
      if (tier === 'EVENT') {
        return `bs_pass_product_name_basic` as const
      }

      return `bs_pass_product_name${translationTierSuffix(tier)}` as const
    case 'cr':
      if (tier === 'DEFAULT') {
        return `cr_pass_product_name_basic` as const
      }

      if (tier === 'EVENT') {
        return `cr_pass_product_name_basic` as const
      }

      return `cr_pass_product_name${translationTierSuffix(tier)}` as const
    case 'hd':
      if (tier === 'EVENT') {
        return `hd_pass_product_name_basic` as const
      }

      return `hd_pass_product_name${translationTierSuffix(tier)}` as const
    case 'sb':
      return null
  }
}

export const imageTierSuffix = (tier: SCIDShopItemTier) => {
  switch (tier) {
    case 'PREMIUM':
      return 'Premium'
    case 'BASIC':
      return 'Basic'
    case 'DEFAULT':
      return 'Default'
    case 'EVENT':
      return 'Event'
    default:
      const other: never = tier
      throw new Error(`Unknown tier ${other}`)
  }
}
